// extracted by mini-css-extract-plugin
module.exports = {"i1nu0br4":"i1nu0br4"};